import { render, staticRenderFns } from "./ModalBannerCourier.vue?vue&type=template&id=a98197b8&"
import script from "./ModalBannerCourier.vue?vue&type=script&lang=js&"
export * from "./ModalBannerCourier.vue?vue&type=script&lang=js&"
import style0 from "./ModalBannerCourier.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports